import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://api.policorp.com.br',
});

export default instance;